import { useCallback } from "react";
import { getDownloadURL, ref as storageRef } from "firebase/storage";
import { storage } from "../firebase";

export const useGetGameImage = () => {
    const sendRequest = useCallback(
        (requestConfig: { image: string; platform: string }, applyData: (image: string | null) => void) => {
            let gameImagesPath = "";
            switch (requestConfig.platform) {
                case "Commodore 64":
                    gameImagesPath = "c64";
                    break;
                case "Commodore 128":
                    gameImagesPath = "c128";
                    break;
                case "Amiga 500":
                    gameImagesPath = "amiga";
                    break;
                case "Amiga 500+":
                    gameImagesPath = "amiga";
                    break;
                case "Amiga 1200":
                    gameImagesPath = "amiga";
                    break;
                case "PC":
                    gameImagesPath = "pc";
                    break;
                case "ZX Spectrum":
                    gameImagesPath = "zx-spectrum";
                    break;
                case "PC+":
                    gameImagesPath = "pc-plus";
                    break;
                case "MAME":
                    gameImagesPath = "mame";
                    break;
                case "Amiga + AGA":
                    gameImagesPath = "amiga";
                    break;
                case "SNES":
                    gameImagesPath = "snes";
                    break;
                case "NES":
                    gameImagesPath = "nes";
                    break;
                case "PlayStation":
                    gameImagesPath = "playstation";
                    break;
                case "PlayStation 2":
                    gameImagesPath = "playstation-2";
                    break;
            }
            gameImagesPath += "/images/games/";

            const pathReference = storageRef(storage, gameImagesPath + requestConfig.image);

            getDownloadURL(pathReference)
                .then((url) => {
                    applyData(url);
                })
                .catch((error) => {
                    applyData(null);
                });
        },
        []
    );

    return { sendRequest };
};
